import{__require as r}from"./math-trunc.js";var t,e;function n(){if(e)return t;e=1;var n=r();return t=function(r){var t=+r;return t!=t||0===t?0:n(t)}}export{n as __require};
//# sourceMappingURL=to-integer-or-infinity.js.map
